import { useNavigate } from 'react-router-dom';
import { PageShell, UnderlineTabs, type UnderlineTabsTab } from '@/shared/components';
import { usePersistedTab } from '@/shared/hooks/usePersistedFilters';
import { EmployeesTab } from '@/features/teams/components/tabs/EmployeesTab';

type Scope = 'active' | 'former' | 'all';

const TABS: readonly UnderlineTabsTab<Scope>[] = [
  { value: 'active', label: 'Active' },
  { value: 'former', label: 'Former' },
  { value: 'all', label: 'All' },
];
const VALID_TABS: readonly Scope[] = TABS.map((t) => t.value);

export function HrisEmployeesPage() {
  const navigate = useNavigate();
  const [scope, setScope] = usePersistedTab<Scope>('employees', VALID_TABS, 'active');

  return (
    <PageShell
      tabs={<UnderlineTabs<Scope> tabs={TABS} active={scope} onChange={setScope} />}
    >
      <div className="flex min-h-[calc(100vh-240px)]">
        <div className="flex-1 min-w-0 overflow-auto">
          <EmployeesTab
            key={scope}
            scope={scope}
            onRowClick={(id) => navigate(`/employees/${id}`)}
          />
        </div>
      </div>
    </PageShell>
  );
}
